import { Link } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Badge } from '@/components/ui/badge';
import { Button } from '@/components/ui/button';
import { Handshake } from 'lucide-react';

/**
 * OptiBay Connect card in Shop Profile → Add-Ons & Features.
 *
 * B-S3 / B-P6 (DECISION_LEDGER.md §10; CORE-R Product Tier Core): Connect is included with every Core subscription
 * and every higher tier. It is not a separately purchased add-on, so this card no longer offers an "enable the
 * add-on" switch (that switch only wrote the legacy OPTIBAY_CONNECT key, which no surface needs: the Connect feature
 * flag is granted by the Core preset). The shop's real operational preference is its recruiting posture
 * (Connect → "Actively Hiring", owners/managers only). A technician's visibility is always their own choice.
 * Existing shops.addons values are left exactly as they are (B-P6-4).
 */
export function OptiBayConnectToggle() {
  return (
    <Card data-testid="optibay-connect-core-card">
      <CardHeader className="pb-3">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
              <Handshake className="h-5 w-5 text-primary" />
            </div>
            <div>
              <CardTitle className="text-base flex items-center gap-2">
                OptiBay Connect
                <Badge variant="outline" className="text-xs">Included in Core</Badge>
              </CardTitle>
              <CardDescription>Hiring and career portability, part of every OptiBay plan</CardDescription>
            </div>
          </div>
          <Button asChild variant="outline" size="sm">
            <Link to="/connect">Open Connect</Link>
          </Button>
        </div>
      </CardHeader>
      <CardContent className="pt-0 space-y-1">
        <p className="text-sm text-muted-foreground">
          Owners and managers set whether your shop is actively hiring from the Connect page.
        </p>
        <p className="text-sm text-muted-foreground">
          Technicians decide for themselves whether shops can see them. Turning hiring on never makes anyone visible.
        </p>
      </CardContent>
    </Card>
  );
}
